import { loginBaseUrl } from "../api/Constants";

const resellers = {
	dealerClick: {
		DC_CompanyName: "DealerClick",
		DC_Company_Website: "www.dealerclick.com",
		DC_Company_Logo: "logo.svg",
		DC_Login_Logo: "logo-dark.svg",
		BrandCode: 1,
		RemoteConnect: "https://connect.dealerclick.org/",
		appUrl:
			loginBaseUrl === "https://autocoin.us"
				? "https://app.dealerclick.com"
				: "https://dealerclick.app",
		isDealerClick: true,
	},
	dealermate: {
		DC_CompanyName: "Dealer-mate",
		DC_Company_Website: "https://dealer-mate.com/",
		DC_Company_Logo: "dm__logo_white.png",
		DC_Login_Logo: "dm__logo_color.png",
		BrandCode: 3,
		RemoteConnect: "https://dealermate.screenconnect.com/",
		appUrl: "https://dealer-mate.app",
		isDealerClick: false,
	},
};

export default resellers;
